export const FA_STORAGE_KEY = "firestoreAdmin.darkMode";
export const FA_FAVORITES_KEY = "firestoreAdmin.favorites";
export const FA_RECENT_KEY = "firestoreAdmin.recent";
export const FA_SIDEBAR_WIDTH_KEY = "firestoreAdmin.sidebarWidth";

export const BACKUP_COLLECTION = "firestore_backups";
export const AUDIT_COLLECTION = "admin_logs";
export const SCHEDULER_COLLECTION = "firestore_admin_schedules";

export const PAGE_LIMIT_OPTIONS = [50, 100, 250, 500];
export const BATCH_SIZE = 400;
export const DELETE_BATCH_SIZE = 500;

export const CONDITION_OPS = [
  { id: "==", label: "==" },
  { id: "!=", label: "!=" },
  { id: ">", label: ">" },
  { id: "<", label: "<" },
  { id: ">=", label: ">=" },
  { id: "<=", label: "<=" },
  { id: "in", label: "in" },
  { id: "not-in", label: "not-in" },
  { id: "array-contains", label: "array-contains" },
  { id: "array-contains-any", label: "array-contains-any" },
];

export const DELETE_BY_CONDITION_OPS = CONDITION_OPS.filter((o) =>
  ["==", "!=", ">", "<", ">=", "<=", "array-contains", "in"].includes(o.id)
);

export const UPDATE_TYPES = [
  { id: "setValue", label: "Set Value" },
  { id: "replaceValue", label: "Replace Value" },
  { id: "increment", label: "Increment Number" },
  { id: "decrement", label: "Decrement Number" },
  { id: "appendText", label: "Append Text" },
  { id: "removeText", label: "Remove Text" },
  { id: "uppercase", label: "Uppercase" },
  { id: "lowercase", label: "Lowercase" },
  { id: "trim", label: "Trim" },
  { id: "setNull", label: "Set Null" },
  { id: "deleteField", label: "Delete Field" },
  { id: "renameField", label: "Rename Field" },
  { id: "copyField", label: "Copy Field" },
  { id: "moveField", label: "Move Field" },
];

export const ADMIN_NAV = [
  { id: "dashboard", path: "", label: "Dashboard", icon: "dashboard" },
  { id: "explorer", path: "explorer", label: "Collection Explorer", icon: "table_chart" },
  { id: "update-condition", path: "update-condition", label: "Update by Condition", icon: "edit_note" },
  { id: "delete-condition", path: "delete-condition", label: "Delete by Condition", icon: "delete_forever" },
  { id: "find-replace", path: "find-replace", label: "Find & Replace", icon: "find_replace" },
  { id: "undo", path: "undo", label: "Undo Center", icon: "undo" },
  { id: "scheduler", path: "scheduler", label: "Scheduler", icon: "schedule" },
  { id: "duplicates", path: "duplicates", label: "Duplicate Finder", icon: "content_copy" },
  { id: "relationships", path: "relationships", label: "Relationships", icon: "account_tree" },
  { id: "restore", path: "restore", label: "Restore Center", icon: "history" },
  { id: "query", path: "query", label: "Query Builder", icon: "filter_list" },
  { id: "analyzer", path: "analyzer", label: "Analyzer", icon: "analytics" },
  { id: "schema-guard", path: "schema-guard", label: "Schema Guard", icon: "fact_check" },
  { id: "index-advisor", path: "index-advisor", label: "Index Advisor", icon: "bolt" },
  { id: "saved-views", path: "saved-views", label: "Saved Views", icon: "bookmark" },
  { id: "fields", path: "fields", label: "Field Manager", icon: "view_column" },
  { id: "import-export", path: "import-export", label: "Import / Export", icon: "upload_file" },
  { id: "audit", path: "audit", label: "Audit Log", icon: "receipt_long" },
  { id: "monitor", path: "monitor", label: "Monitor", icon: "monitor_heart" },
  { id: "search", path: "search", label: "Smart Search", icon: "search" },
  { id: "permissions", path: "permissions", label: "Permissions", icon: "admin_panel_settings" },
];
